<template>
  <Head title="Welcome" />

  <div class="flex flex-col min-h-screen bg-gray-100 home-bg">
    <div class="flex flex-row justify-between w-100 z-10 relative">
      <div
        id="logo"
        class="text-left p-5"
      >
        <img
          :src="asset('images/logo.png')"
          class="w-44"
        />
      </div>
      <div
        v-if="canLogin"
        class="fixed top-0 right-0 px-6 py-4 sm:block"
      >
        <Link
          v-if="$page.props.auth.user"
          href="/dashboard"
          class="block transition-all text-blue-600 px-6 py-3 font-bold tracking-wide bg-gray-400 uppercase rounded hover:bg-blue-600 hover:text-gray-400"
        >
          Dashboard
        </Link>

        <template v-else>
          <a
            :href="route('login')"
            class="block transition-all text-blue-600 px-6 py-3 font-bold tracking-wide bg-gray-400 uppercase rounded hover:bg-blue-600 hover:text-gray-400"
          >
            Login
          </a>
          <!-- <Link v-if="canRegister" :href="route('register')" class="ml-4 text-sm text-gray-700 underline">
                        Register
                    </Link> -->
        </template>
      </div>
    </div>

    <div class="w-100 flex h-100 grow">
      <div
        class="flex flex-row text-blue-600 self-auto sm:self-center mt-10 sm:-mt-40 mx-auto max-w-full md:max-w-6xl container relative z-10"
      >
        <div class="w-full sm:w-1/2 bg-gray-100 bg-opacity-95 px-5">
          <svg
            width="128px"
            height="118px"
            viewBox="0 0 128 118"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <polygon
                id="path-6gdbxbi-xy-1"
                points="0 0 26.0853081 0 26.0853081 61.7230769 0 61.7230769"
              ></polygon>
              <polygon
                id="path-6gdbxbi-xy-3"
                points="0 0 60.6635071 0 60.6635071 62.3282051 0 62.3282051"
              ></polygon>
            </defs>
            <g
              id="Diagrams"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="Slide-(16:9)-Copy"
                transform="translate(-273.000000, -353.000000)"
              >
                <g
                  id="Group-2"
                  transform="translate(273.000000, 353.000000)"
                >
                  <path
                    d="M50.3507109,108.071319 C50.3507109,105.329381 51.8442704,102.84721 54.2576867,101.049061 C54.4428387,100.922371 54.6215506,100.79568 54.8002625,100.66899 C58.3278108,98.1335886 61.2285257,95.0105149 63.4449831,91.5158875 C63.564661,91.3269167 63.8346073,91.3274491 63.9537486,91.5158875 C66.1648393,95.0110472 69.0650174,98.1335886 72.5925657,100.66899 C72.7712777,100.79568 72.9499896,100.922371 73.1351416,101.049061 C75.5485578,102.84721 77.042654,105.329381 77.042654,108.071319 C77.042654,113.555196 71.0668058,118 63.6999025,118 C56.3260224,118 50.3507109,113.555196 50.3507109,108.071319"
                    id="Fill-12"
                    fill="#E2EBED"
                  ></path>
                  <g
                    id="Group-16"
                    transform="translate(50.957346, 0.000000)"
                  >
                    <mask
                      id="mask-6gdbxbi-xy-2"
                      fill="white"
                    >
                      <use xlink:href="#path-6gdbxbi-xy-1"></use>
                    </mask>
                    <g id="Clip-15"></g>
                    <path
                      d="M13.5605358,0.214972351 C13.2779583,-0.0718723153 12.8121302,-0.0718723153 12.5295527,0.214435189 C4.78522786,8.06291351 0,18.8990885 0,30.8611557 C0,42.8237601 4.78522786,53.6599351 12.5295527,61.5084134 C12.8121302,61.7947209 13.2779583,61.7947209 13.5605358,61.5078762 C21.3000802,53.6545635 26.0853081,42.8237601 26.0853081,30.8611557 C26.0853081,18.8990885 21.3000802,8.06774797 13.5605358,0.214972351"
                      id="Fill-14"
                      fill="#E2EBED"
                      mask="url(#mask-6gdbxbi-xy-2)"
                    ></path>
                  </g>
                  <path
                    d="M127.775003,71.0158405 C126.266445,69.5816048 124.566563,68.3086336 122.685568,67.2231792 C121.057702,66.2855951 119.375018,65.5408855 117.655788,64.9783351 C112.695337,63.3496177 107.46026,63.2478229 102.591171,64.5122219 C100.409217,65.08013 98.3025026,65.9159192 96.3253084,67.0142319 C98.0982803,65.931992 99.7755902,64.6783082 101.333591,63.2585381 C103.789633,61.0244093 105.95009,58.3831012 107.702639,55.3560442 C108.175038,54.5416855 108.604979,53.7166115 108.997838,52.8808223 C111.131961,48.3761329 112.149848,43.5939186 112.144474,38.8636732 C112.143937,38.4677448 111.820405,38.1403941 111.423247,38.1323576 C100.467259,37.9068017 89.4430175,41.7926857 80.8742805,49.7841162 C80.5190412,50.1162888 80.1643394,50.4538191 79.8150118,50.8020646 C74.2257704,56.3793502 70.4745295,63.0978094 68.5779494,70.2073752 C68.1689674,71.7075097 67.8524229,73.223717 67.615955,74.7506395 C67.5885462,74.900653 67.5670491,75.0506664 67.545552,75.2006799 C67.5186807,75.4096272 67.486435,75.6239321 67.464938,75.8328794 C67.3789496,76.577589 67.3364929,77.3383715 67.3364929,78.1098692 C67.3364929,78.6563467 67.3574525,79.1974667 67.4004467,79.733229 C67.5240549,81.2547939 67.8142655,82.7281402 68.2554932,84.1371951 C68.9165284,86.2534562 69.921517,88.2250615 71.2005934,89.9823618 C72.033068,91.0699593 72.9579799,92.0986229 73.9678054,93.0576374 C73.9790913,93.0683527 73.9946767,93.0790679 74.011337,93.1004984 C75.5107585,94.5256261 77.2084905,95.7953828 79.0846484,96.8776227 C80.712515,97.8152067 82.3951991,98.5599163 84.1144282,99.1224667 C88.3015225,100.500447 92.6847776,100.785473 96.877246,100.076124 C97.345345,99.9968308 97.6140585,99.4862493 97.4135982,99.0565679 C97.0035414,98.1784535 96.5451161,97.318555 96.0399347,96.4865162 C94.0842376,93.2665847 91.4126877,90.4216869 88.102137,88.203631 C89.929389,88.4393664 91.7894241,88.5572341 93.6811673,88.5572341 C97.9209294,88.5572341 102.016124,87.9518227 105.890973,86.8213642 C110.319909,85.5301771 114.45756,83.5532142 118.176555,81.0137009 C121.842345,78.5181201 125.102915,75.4733829 127.842718,71.9995001 C128.075424,71.7042951 128.047478,71.2746137 127.775003,71.0158405"
                    id="Fill-17"
                    fill="#E2EBED"
                  ></path>
                  <g
                    id="Group-21"
                    transform="translate(0.000000, 38.123077)"
                  >
                    <mask
                      id="mask-6gdbxbi-xy-4"
                      fill="white"
                    >
                      <use xlink:href="#path-6gdbxbi-xy-3"></use>
                    </mask>
                    <g id="Clip-20"></g>
                    <path
                      d="M60.4539118,37.0777443 C60.4324148,36.9277303 60.4109178,36.7777163 60.3840466,36.6277023 C60.1475801,35.1007739 59.8304999,33.5845608 59.4220577,32.0844206 C57.524951,24.9748277 53.7737315,18.2563428 48.1845219,12.679036 C47.8351963,12.3307892 47.4804965,11.9932576 47.1257966,11.6610837 C38.5571084,3.66962276 27.5323926,-0.216276038 16.5770044,0.00928075186 C16.1793106,0.0173172171 15.8557814,0.344669232 15.855244,0.740599084 C15.8498697,5.47086249 16.8682882,10.253095 19.0023989,14.7578017 C19.3947184,15.593594 19.8246576,16.4186711 20.2975907,17.2330329 C22.049593,20.2601015 24.2100374,22.9014197 26.6660651,25.135557 C28.2245947,26.5553326 29.9013575,27.8090211 31.6748567,28.8912651 C29.6971364,27.7929482 27.5904344,26.9571558 25.4084929,26.3892456 C20.5394315,25.1248418 15.3049218,25.226637 10.3444983,26.8553606 C8.62474152,27.4179132 6.94260441,28.1626256 5.31420971,29.1002132 C3.43376314,30.185136 1.73335362,31.4586479 0.224804458,32.892889 C-0.0476695085,33.1516632 -0.0756155563,33.5813462 0.157089034,33.8765524 C2.89687657,37.3504484 6.15796538,40.3951972 9.82319704,42.8907875 C13.5421711,45.4303105 17.6803359,47.4072809 22.1087096,48.698473 C25.9835366,49.8289358 30.0787075,50.4343495 34.3189828,50.4343495 C36.2107153,50.4343495 38.0702023,50.3164813 39.8974439,50.080745 C36.5869121,52.2988094 33.9159148,55.1437181 31.9596915,58.3636618 C31.4545129,59.1957038 30.9960902,60.0556056 30.5860357,60.9337234 C30.3855766,61.3628706 30.6542886,61.8739898 31.1223849,61.9532829 C35.3148295,62.6620991 39.6980596,62.3776083 43.8851299,60.9996224 C45.6048867,60.4370698 47.2870238,59.6923574 48.9154185,58.7547698 C50.7910283,57.6725258 52.4892881,56.4027643 53.9887011,54.9776311 C54.0048238,54.9562005 54.0209465,54.9454853 54.031695,54.93477 C55.0420521,53.9757518 55.9664214,52.9470842 56.7994286,51.8594826 C58.0784977,50.1021756 59.0834806,48.1305628 59.7445121,46.0142936 C60.1851998,44.6052334 60.4754087,43.1318814 60.5990162,41.6103107 C60.6420101,41.0745463 60.6635071,40.5334244 60.6635071,39.9869447 C60.6635071,39.2154441 60.6205132,38.4546587 60.5345253,37.7099462 C60.5130284,37.5009982 60.480783,37.2866924 60.4539118,37.0777443"
                      id="Fill-19"
                      fill="#E2EBED"
                      mask="url(#mask-6gdbxbi-xy-4)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <h1
            class="tracking-widest uppercase mt-7"
            style="font-size: 2.5rem; line-height: 3rem"
          >
            Connecting <br /><b>Cannabis.</b>
          </h1>
          <p class="tracking-wide font-normal my-5 text-lg">
            Salve is a single-source of confidence for the business across an unlimited number of software providers.
            Giving the power and control back to the business owner to make decisions faster without systematic concerns
          </p>
          <a
            target="_blank"
            class="inline-block transition-all bg-blue-600 hover:text-blue-600 px-6 py-3 font-bold tracking-wide uppercase rounded hover:bg-gray-300 text-gray-400"
            href="https://getsalve.co"
            >Learn More</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'

export default {
  components: {
    Head,
    Link
  },
  props: {
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String
  }
}
</script>
